module.exports = __webpack_public_path__ + "assets/icon-consultation-selected.dec916b5.svg";